import { render } from "./simulate.vue?vue&type=template&id=29d46b9e"
import script from "./simulate.vue?vue&type=script&lang=ts"
export * from "./simulate.vue?vue&type=script&lang=ts"
script.render = render

export default script